<template>
  <div class="app-container">
    <navigation title="请您关注"></navigation>
    <div class="content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell :title="item.title" is-link v-for="item in list" :to="{name:'applicationDetails',query:{id:item.id}}">
          <template #label>
            <p class="message" v-text="item.introduce"></p>
          </template>
          <template #icon>
            <img :src="baseUrl+item.logoPath" alt="" class="list-img">
          </template>
          <template #right-icon>
            <span class="enter"></span>
          </template>
        </van-cell>
      </van-list>
    </div>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { Cell, CellGroup, List, Icon, Checkbox } from 'vant'
import { request } from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'

Vue.use(Cell).use(CellGroup).use(List).use(Icon).use(Checkbox)
export default {
  name: 'application',
  components: {navigation, version},
  data () {
    return {
      baseUrl: process.env.API_ROOT,
      list: [],
      loading: false,
      finished: false,
      params: {
        pageNum: '1',
        pageSize: '10'
      }
    }
  },
  created () {
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    onLoad () {
      request('get', '/nlc-web/api/app', this.params).then(res => {
        console.log('应用荟萃', res)
        for (var i = 0; i < res.data.content.length; i++) {
          this.list.push(res.data.content[i])
        }
        // 加载状态结束
        this.loading = false
        if (res.data.totalElements === this.list.length) {
          this.finished = true
        }
      })
      this.params.pageNum++
    }
  }
}
</script>

<style scoped>
.app-container{
  overflow-y:scroll;
}
.content{
  width: 6.94rem;
  margin:.92rem .28rem .16rem .28rem;
  border-radius:8px;
  background:#fff;
  padding:0;
}
.list-img{
  width:1.46rem;
  height:1.46rem;
  margin:0 .4rem 0 0;
  border-radius:16px;
}
.enter{
  width:.13rem;
  height:.24rem;
  margin:.5rem 0 0 .24rem;
  background-size:100%;
}
>>>.van-cell__title{
  width:1.5rem;
}
.message{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
p{
  margin:0;
  padding:0;
}
</style>



// WEBPACK FOOTER //
// src/view/application/index.vue